'use client';

import { FC } from 'react';
import { OwSlide } from '../../interfaces/domain/ow-carousel.modal';
import OWLink from '../shared/ow-link';
import useIsOverwolfIframe from '../../hooks/use-is-overwolf-iframe';

interface CarouselImageSliderItemProps {
  item: OwSlide;
}

// -----------------------------------------------------------------------------
// Tags the CTA link so the app page it lands on knows the visit came from a
// carousel slide click (see use-download-click-handler's origin.fromCarousel).
// Only relevant inside the Overwolf app — the param would be dead weight on
// the plain web, where there's no native install call to feed it.
// `link` is an absolute URL (https://domain.com/...), so we parse it as-is and
// preserve the full origin — stripping it would break any off-site slide.
const withCarouselOrigin = (link: string): string => {
  try {
    const url = new URL(link);
    url.searchParams.set('origin', 'carousel');
    return url.toString();
  } catch {
    return link;
  }
};

// -----------------------------------------------------------------------------
const CarouselImageSliderItem: FC<CarouselImageSliderItemProps> = props => {
  const { link, title, imagePath, logoPath, hidden } = props.item;
  const { isOverwolfIframe } = useIsOverwolfIframe();

  if (hidden) {
    return <></>;
  }

  return (
    <li className='swiper-slide'>
      <img className='bg-image' src={imagePath} alt={title} />

      <OWLink href={isOverwolfIframe ? withCarouselOrigin(link) : link}>
        <img className='cta-image' src={logoPath} alt={title} />
      </OWLink>
    </li>
  );
};

export default CarouselImageSliderItem;
